import { FilterOnEmptyState, LiveFeedback, LoadingSpinner, NoFlyersAvailableEmptyState } from '@/components';
import { FlyerList } from '@/components/FlyerboardPagination/FlyerList';
import AuthenticationContext from '@/context/AuthenticationContext';
import { useJarFlyerboardContext } from '@/context/JarFlyerboardContext';
import { useJarFlyerboardPagination, useLiveFeedback, useSchools, useURLSearchParams } from '@/hooks';
import { css } from '@emotion/css';
import { useContext } from 'react';

export const JarFlyerboardList = () => {
  const { audienceId } = useURLSearchParams();
  const { schoolsIds } = useSchools();
  const { isAuthenticated } = useContext(AuthenticationContext);
  const [liveMessage, setLiveMessage] = useLiveFeedback({ delay: 2500 });
  const { filters, resetQuickFilters, amountActiveFilters, districtId } = useJarFlyerboardContext();

  const { flyers, loading, fetchMoreFlyers, total, dataNotFound } = useJarFlyerboardPagination({
    audienceId,
    districtId,
    flyerboardFilters: filters || { schoolIds: [] },
    skip: !filters,
    skipExpandedCommunityFlyers:
      isAuthenticated && schoolsIds.length !== filters?.schoolIds?.length,
  });

  const resetFilters = () => {
    resetQuickFilters();
    setLiveMessage('Filters reset.');
  };

  const EmptyState = () => {
    if (dataNotFound) {
      if (amountActiveFilters > 0) {
        return <FilterOnEmptyState onClick={resetFilters} />;
      }
      return <NoFlyersAvailableEmptyState />;
    }
    return null;
  };

  return (
    <main className={cn.container}>
      <LiveFeedback message={liveMessage} />
      {loading && flyers.length === 0 && <LoadingSpinner />}
      <EmptyState />
      {flyers.length > 0 && (
        <>
          <FlyerList
            flyers={flyers}
            nextPage={fetchMoreFlyers}
            total={total}
            trackId="jar"
            audienceId={audienceId}
            districtId={districtId}
            trackingEventFrom="jar"
            showTags
          />
        </>
      )}
    </main>
  );
};

const cn = {
  container: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    flex-grow: 10;
  `,
};